import { createTheme } from '@mui/material/styles'

const MuiTheme = createTheme({
  palette: {
    mode: 'dark',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF4E',
      disabled: '#FFFFFF2E'
    },
    primary: {
      main: '#0085CA',
      dark: '#0085CA',
      light: '#C2EBFF',
      contrast: '#00000057',
      hover: '#33B1F208',
      selected: '#33B1F20F',
      focus: '#33B1F20B',
      focusVisible: '#33B1F21D',
      outlinedBorder: '#33B1F232'
    },
    secondary: {
      main: '#FFC340',
      dark: '#CC9316',
      light: '#FFE19E',
      contrast: '#00000057'
    },
    error: {
      main: '#F55B6D',
      dark: '#D43749',
      light: '#FCB1BA',
      contrast: '#00000057'
    },
    warning: {
      main: '#FFA726',
      dark: '#F57C00',
      light: '#FFB74D',
      contrast: '#00000057'
    },
    info: {
      main: '#6EE0DD',
      dark: '#2B8A87',
      light: '#8AE6E3',
      contrast: '#00000057'
    },
    success: {
      main: '#8FDE3C',
      dark: '#539111',
      light: '#A7E861',
      contrast: '#00000057'
    },
    background: {
      default: '#121212',
      'paper-elevation-0': '#121212',
      'paper-elevation-1': 'rgba(30, 30, 30, 1)',
      'paper-elevation-2': '#232323',
      'paper-elevation-16': '#363636',
      'paper-elevation-24': '#383838'
    },
    action: {
      active: '#FFFFFF38',
      hover: '#FFFFFF08',
      selected: '#FFFFFF0F',
      disabledBackground: '#FFFFFF0B',
      focus: '#FFFFFF0B',
      disabled: '#FFFFFF26'
    },
    token: {
      divider: '#FFFFFF0B'
    },
    common: {
      white: '#FFFFFF',
      black: '#FFFFFF'
    }
  },
  typography: {
    h1: {
      WebkitFontSmoothing: 'antialiased',
      fontWeight: '800',
      fontSize: '6rem',
      lineHeight: '112.03px',
      letterSpacing: '-1.5px'
    },
    h2: {
      fontWeight: '600',
      fontSize: '60px',
      lineHeight: '72px',
      letterSpacing: '-0.5px'
    },
    h3: {
      fontWeight: '900',
      fontSize: '48px',
      lineHeight: '56.02px'
    },
    h4: {
      fontWeight: '800',
      fontSize: '34',
      lineHeight: '41.99px',
      letterSpacing: '0.25px'
    },
    h5: {
      fontWeight: '700',
      fontSize: '24px',
      lineHeight: '32.02px'
    },
    h6: {
      fontWeight: '700',
      fontSize: '20px',
      lineHeight: '32px',
      letterSpacing: '0.15px'
    },
    subtitle1: {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '0.15px'
    },
    subtitle2: {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '21.98px',
      letterSpacing: '0.1px'
    },
    body1: {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px'
    },
    body2: {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20.02px',
      letterSpacing: '0.17px'
    },
    caption: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '19.92px',
      letterSpacing: '0.4px'
    },
    overline: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '39.92px',
      letterSpacing: '1px'
    },
    fontFamily: [
      'Montserrat',
      'Helvetica',
      'Arial',
      'sans-serif'
    ].join(',')
  }
})

export default MuiTheme
